<div class="commodities-table-container">
    <table mat-table [dataSource]="commodityRows()" [trackBy]="trackBy" class="commodity-table">

        <!-- Selection -->
        <ng-container matColumnDef="select">
            <th mat-header-cell class="min-w-10 max-w-10" *matHeaderCellDef>
                <mat-checkbox (change)="toggleSelection()" [checked]="isAllSelected()" [indeterminate]="isSelectionIndeterminate()"></mat-checkbox>
            </th>
            <td mat-cell class="checkbox min-w-10 max-w-10" *matCellDef="let row; let i = index">
                <mat-checkbox
                        class="selector"
                        color="primary"
                        [checked]="isSelected(row.commodityIndex)"
                        (change)="toggleSelectRow(row.commodityIndex)"
                ></mat-checkbox>
            </td>
        </ng-container>

        <!-- Quantity -->
        <ng-container matColumnDef="quantity">
            <th mat-header-cell class="number max-w-12 min-w-12" *matHeaderCellDef i18n>Qty</th>
            <td mat-cell class="number max-w-12 min-w-12" *matCellDef="let row; let i = index">
                <input class="w-full" matInput type="number" min="1" [value]="row.commodity.quantity || 1" (blur)="onFieldBlur(row.commodityIndex, 'quantity', $event)">
            </td>
        </ng-container>

        <!-- Description -->
        <ng-container matColumnDef="description">
            <th mat-header-cell class="text min-w-18" *matHeaderCellDef i18n>Description</th>
            <td mat-cell class="text w-30 min-w-18" *matCellDef="let row; let i = index">
                <input class="w-full" matInput type="text" [value]="row.commodity.description || ''" (blur)="onFieldBlur(row.commodityIndex, 'description', $event)">
            </td>
        </ng-container>

        <!-- Code -->
        <ng-container matColumnDef="country">
            <th mat-header-cell class="select max-w-20 min-w-12" *matHeaderCellDef i18n>Country</th>
            <td mat-cell class="select max-w-20 min-w-12" *matCellDef="let row; let i = index">
                <input class="w-full" matInput type="text" [matAutocomplete]="countryAuto" [value]="row.commodity.country || ''" (input)="onCountryFilter($event)" (blur)="onFieldBlur(row.commodityIndex, 'country', $event)">
                <mat-autocomplete #countryAuto="matAutocomplete">
                    @for (choice of countryFilter$ | async; track choice) {
                        <mat-option [value]="choice.value">
                            {{ choice.label }}
                        </mat-option>
                    }
                </mat-autocomplete>
            </td>
        </ng-container>

        <!-- Weight -->
        <ng-container matColumnDef="weight">
            <th mat-header-cell class="number max-w-16 min-w-14" *matHeaderCellDef i18n>Weight</th>
            <td mat-cell class="number max-w-16 min-w-14" *matCellDef="let row; let i = index">
                <input matInput type="number" class="w-full" min="1" [value]="row.commodity.weight | digits" (blur)="onFieldBlur(row.commodityIndex, 'weight', $event)">
            </td>
        </ng-container>

        <!-- Pieces -->
        <ng-container matColumnDef="pieces">
            <th mat-header-cell class="number max-w-16 min-w-14" *matHeaderCellDef i18n>Pieces</th>
            <td mat-cell class="number max-w-16 min-w-14" *matCellDef="let row; let i = index">
                <input matInput type="number" class="w-full" min="1" [value]="row.commodity.pieces | digits" (blur)="onFieldBlur(row.commodityIndex, 'pieces', $event)">
            </td>
        </ng-container>

        <!-- Units of Measure -->
        <ng-container matColumnDef="unitOfMeasure">
            <th mat-header-cell class="text min-w-20 w-30" *matHeaderCellDef i18n>Units</th>
            <td mat-cell class="text min-w-20 w-30" *matCellDef="let row; let i = index">
                <input matInput [matAutocomplete]="uomAuto" type="text" class="w-full" [value]="row.commodity.unitOfMeasure" (blur)="onFieldBlur(row.commodityIndex, 'unitOfMeasure', $event)">
                <mat-autocomplete #uomAuto="matAutocomplete">
                    @for (choice of unitsOfMeasure; track choice) {
                        <mat-option [value]="choice.value">
                            {{ choice.label }}
                        </mat-option>
                    }
                </mat-autocomplete>
            </td>
        </ng-container>

        <!-- Value -->
        <ng-container matColumnDef="price">
            <th mat-header-cell class="number max-w-20 min-w-14" *matHeaderCellDef i18n>Price</th>
            <td mat-cell class="number max-w-20 min-w-14" *matCellDef="let row; let i = index">
                <input matInput type="number" class="w-full" min="1" [value]="row.commodity.price | digits" (blur)="onFieldBlur(row.commodityIndex, 'price', $event)">
            </td>
        </ng-container>

        <!-- Package Identifier -->
        <ng-container matColumnDef="package">
            <th mat-header-cell class="text min-w-18" *matHeaderCellDef i18n>Package</th>
            <td mat-cell colspan="6" class="package w-full min-w-18" *matCellDef="let row; let i = index">
                Package #{{ row.packageIndex + 1 }} - {{ row.caption }}
            </td>
        </ng-container>

        <!-- Length -->
        <ng-container matColumnDef="length">
            <th mat-header-cell class="number max-w-14 min-w-14" *matHeaderCellDef i18n>Length</th>
            <td mat-cell class="number max-w-14 min-w-14" *matCellDef="let row; let i = index">
                <input matInput type="number" class="w-full" min="1" [value]="row.commodity.length | digits" (blur)="onFieldBlur(row.commodityIndex, 'length', $event)">
            </td>
        </ng-container>

        <!-- Width -->
        <ng-container matColumnDef="width">
            <th mat-header-cell class="number max-w-14 min-w-14" *matHeaderCellDef i18n>Width</th>
            <td mat-cell class="number max-w-14 min-w-14" *matCellDef="let row; let i = index">
                <input matInput type="number" class="w-full" min="1" [value]="row.commodity.width | digits" (blur)="onFieldBlur(row.commodityIndex, 'width', $event)">
            </td>
        </ng-container>

        <!-- Height -->
        <ng-container matColumnDef="height">
            <th mat-header-cell class="number max-w-14 min-w-14" *matHeaderCellDef i18n>Height</th>
            <td mat-cell class="number max-w-14 min-w-14" *matCellDef="let row; let i = index">
                <input matInput type="number" class="w-full" min="1" [value]="row.commodity.height | digits" (blur)="onFieldBlur(row.commodityIndex, 'height', $event)">
            </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns; when: isCommodityRow"></tr>
        <tr mat-row *matRowDef="let row; columns: ['package']; when: isHeaderRow"></tr>
    </table>
</div>

<div class="commodities-footer mt-2">
    <div class="flex flex-row">
        <div class="buttons">
            @if (packages().length > 1) {
                <button matButton [matMenuTriggerFor]="addMenu">Add Commodity</button>
                <mat-menu #addMenu>
                    @for (p of packages(); let i = $index; track p) {
                        <button mat-menu-item (click)="addEmptyCommodity(i)">Package #{{ i + 1 }} - {{ p.description }}</button>
                    }
                </mat-menu>
                <button matButton [matMenuTriggerFor]="templateMenu">Saved Commodities</button>
                <mat-menu #templateMenu>
                    @for (p of packages(); let i = $index; track p) {
                        <button mat-menu-item (click)="addTemplateCommodity(i)">Package #{{ i + 1 }} - {{ p.description }}</button>
                    }
                </mat-menu>
                <button matButton [matMenuTriggerFor]="packageMenu" [disabled]="selectedIds.size === 0">Change Package</button>
                <mat-menu #packageMenu>
                    @for (p of packages(); let i = $index; track p) {
                        <button mat-menu-item (click)="moveToPackage(i)">Package #{{ i + 1 }} - {{ p.description }}</button>
                    }
                </mat-menu>
            } @else {
                <button matButton (click)="addEmptyCommodity(0)" [disabled]="packages().length == 0" i18n>Add Commodity</button>
                <button matButton (click)="addTemplateCommodity(0)" [disabled]="packages().length == 0" i18n>Saved Commodities</button>
            }
            <button matButton (click)="deleteCommodities()" i18n [disabled]="selectedIds.size === 0">Delete</button>
        </div>
        <div class="m-auto">
        </div>
        <div class="information flex flex-row gap-2">
            <div class="summary">
                <div class="property">Total Weight</div>
                <div class="value" [class.highlight]="false">
                    {{ totalWeight() | number:'1.1-2' }}
                    <small>{{ weightUnit() }}</small>
                </div>
            </div>
            <div class="summary">
                <div class="property">Total Value</div>
                <div class="value">
                    {{ totalValue() | currency:currency()  }}
                </div>
            </div>
        </div>
    </div>
</div>
